import { styled } from "@mui/material";
import Component from "./component";

export default styled(Component)(({ theme }) => ({
  ".status-button-group": {
    padding: theme.spacing(0.2, 0.8),
    ".MuiFormGroup-root": {
      gap: theme.spacing(1),
    },
    ".MuiButtonBase-root": {
      border: "1px solid #eee",
      padding: theme.spacing(0.5),
    },
    ".Mui-checked": {
      backgroundColor: theme.palette.primary.main,
      path: {
        fill: "#fff",
      },
    },
  },
}));
